/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'underscore',
	'./SchematicEditorUI',
	'../VIPRConfig'
], function(
	_,
	SchematicEditorUI
) {

	return class SchematicVis {
		constructor() {
			this.schematicPromises = {};
		}

		destroy () {
			this.schematicPromises = {};
			this.ajaxSvc = null;
			this.schematicEditorUI = null;
		}

		getSchematicContent( payload = {}, dashboardApi) {
			if ( payload.method === 'edit' ) {
				return this._openSchematicEditor(payload, dashboardApi);
			} else if ( payload.method === 'publish' ) {
				// TODO:
			} else if ( payload.method === 'get' ) {
				return this._getSchematicContent( payload, dashboardApi );
			}
		}

		_openSchematicEditor( payload = {}, dashboardApi) {
			const logger = dashboardApi.getGlassCoreSvc('.Logger');
			logger.debug('openSchematicEditorUI');
			return SchematicEditorUI.openSchematicEditor(payload.metadata, dashboardApi);
		}

		// get schematic content for a runtime schematic - either returns a meta.json file
		// or the svg which is to be displayed
		_getSchematicContent( payload = {}, dashboardApi) {
			const logger = dashboardApi.getGlassCoreSvc('.Logger');
			logger.debug('getSchematicContent');
			const key = (payload.type && payload.type === 'meta') ? payload.type : payload.name;

			if (!this.schematicPromises[key]) {
				const param = this._getUrlParm(payload);
				const ajaxSvc = this._getAjaxSvc(dashboardApi);

				this.schematicPromises[key] = ajaxSvc
					.ajax(param).then(response => {
						return response.jqXHR.responseText;
					});
			}

			return this.schematicPromises[key];
		}

		_getUrlParm (payload = {}) {
			const endPoint = SchematicVis.getVisualizationEndPoint() + payload.library + ((payload.type && payload.type === 'meta') ? '/content/meta.json' : ('/content/' + SchematicVis.cleanseFilename(payload.name)));
			return {
				url: endPoint,
				type: payload.method,
				headers: {
					'Content-Type': 'application/xml; charset=utf-8',
					'Accept': 'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*; charset=utf-8'
				}
			};
		}

		_getAjaxSvc (dashboardApi) {
			if (!this.ajaxSvc) {
				this.ajaxSvc = dashboardApi.getGlassCoreSvc('.Ajax');
			}
			return this.ajaxSvc;
		}

		static cleanseFilename(name) {
			const nameParts = name.split('\\');
			name = nameParts.join('/');
			return name;
		}

		static getVisualizationEndPoint() {
			return 'v1/visualizations/';
		}
	};
});
